import { cn } from '@/lib/utils';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    className?: string;
    variant?: 'default' | 'hero';
}

export function PageHeader({ title, subtitle, className, variant = 'default' }: PageHeaderProps) {
    return (
        <header className={cn('pt-6 px-4', className)}>
            <h1 className={cn(
                'text-text-primary',
                variant === 'hero' && 'text-gradient-gold text-[32px] font-black tracking-tight'
            )}>
                {title}
            </h1>
            {subtitle && (
                <p className="text-text-secondary mt-1 font-medium">
                    {subtitle}
                </p>
            )}
        </header>
    );
}
